var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"value":_vm.value,"disabled":_vm.disabled},on:{"change":function($event){return _vm.$emit('input', $event)}}},[_vm._t("default"),_vm._l((_vm.getSchoolEstablishments(_vm.type)),function({ id, name }){return _c('el-option',{key:id,attrs:{"value":id,"label":name}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }